<template>
  <div class="restbooksetting">
    <div>
      <div class="resttitle">
        <div>商店圖示 <button v-if="edit!=='icon'" class="editBtn" @click="edit='icon'"></button></div>
        <template v-if="edit!=='icon'">
          <div class="imagebox2">
            <img v-if="info&&info.icon" :src="`${VUE_APP_HOST}${info.icon}`" :style="{width: '200px', maxWidth: '200px'}">
            <div v-else class="imagebox"></div>
          </div>
        </template>
        <template v-else>
          <File :defaultValue="icon" @input="icon=$event" :folder="'rest'"></File>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({icon})">儲存</button>
          </div>
        </template>
      </div>
      <div class="resttitle">
        <div>簡介首圖 <button v-if="edit!=='restBookImage'" class="editBtn" @click="edit='restBookImage'"></button></div>
        <template v-if="edit!=='restBookImage'">
          <div class="imagebox2">
            <img v-if="info&&info.restBookImage" :src="`${VUE_APP_HOST}${info.restBookImage}`">
            <div v-else class="imagebox"></div>
          </div>
        </template>
        <template v-else>
          <File :defaultValue="image" @input="image=$event" :folder="'rest'"></File>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({restBookImage:image})">儲存</button>
          </div>
        </template>
      </div>
      <div class="resttitle">
        <div>簡介(滾動圖片) <button v-if="edit!=='restBookImageArray'" class="editBtn" @click="imageArray=JSON.parse(JSON.stringify(info.restBookImageArray || []));edit='restBookImageArray'"></button></div>
        <template v-if="edit!=='restBookImageArray'">
          <div class="imagebox2">
            <img v-for="(image, i) in info.restBookImageArray" :key="`image-array-${i}`" :src="`${VUE_APP_HOST}${image}`">
          </div>
        </template>
        <template v-else>
          <draggable class="imagebox2" v-model="imageArray">
            <div class="img" v-for="(image, i) in imageArray" :key="`image-array-${i}`">
              <img :src="`${VUE_APP_HOST}${image}`">
              <button @click="imageArray.splice(i, 1)" class="deleteBtn"></button>
            </div>
          </draggable>
          <File4 @input="addImage2Array" :folder="'rest'" :style="{height: '50px'}" fontSize="20px" accept="image/png, image/jpeg" :text="'上傳圖片'" :bg="'var(--color-checked)'"></File4>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({restBookImageArray:imageArray})">儲存</button>
          </div>
        </template>
      </div>
    </div>
    <div>
      <div class="resttitle">
        <div>簡介 <span :style="{fontSize: '16px', color: '#B9B9B9', alignSelf: 'flex-end', lineHeight: '18px', marginLeft:'.5em'}">(字數限制30字)</span><button v-if="edit!=='desc'" class="editBtn"
          @click="description=info.description;edit='desc'"></button></div>
        <template v-if="edit!=='desc'">
          <div :style="{width: '-webkit-fill-available'}"><p :style="{minHeight: '100px'}" v-html="((info&&info.description)||'').replaceAll('\n', '<br>')"></p></div>
        </template>
        <template v-else>
          <div :style="{width: '100%'}"><textarea :style="{minHeight: '100px'}" v-model="description"></textarea></div>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({description})">儲存</button>
          </div>
        </template>
      </div>
      <div class="resttitle">
        <div>預約須知 <button v-if="edit!=='descBook'" class="editBtn" @click="edit='descBook'"></button></div>
        <template v-if="edit!=='descBook'">
          <div :style="{width: '-webkit-fill-available'}"><p v-html="((info&&info.restBookDescription)||'').replaceAll('\n', '<br>')"></p></div>
        </template>
        <template v-else>
          <div :style="{width: '100%'}"><textarea v-model="restBookDescription"></textarea></div>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({restBookDescription})">儲存</button>
          </div>
        </template>
      </div>
      <div class="resttitle" v-if="info.immediate">
        <div>點餐須知 <button v-if="edit!=='descBook'" class="editBtn" @click="edit='descBook'"></button></div>
        <template v-if="edit!=='descBook'">
          <div :style="{width: '-webkit-fill-available'}"><p v-html="((info&&info.restOrderDescription)||'').replaceAll('\n', '<br>')"></p></div>
        </template>
        <template v-else>
          <div :style="{width: '100%'}"><textarea v-model="restOrderDescription"></textarea></div>
          <div class="btns">
            <button class="cancel" @click="edit=null">取消</button>
            <button class="confirm" @click="update({restOrderDescription})">儲存</button>
          </div>
        </template>
      </div>
      <div class="linkBtns resttitle">
        <div>點擊複製頁面連結</div>
        <button class="linkBtn" @click="copylink('Start')" :title="getLink('Start')">{{info.storeType === 'restaurant' ? '餐廳' : '商店'}}入口</button>
        <button class="linkBtn" @click="copylink('Time')" :title="getLink('Time')">{{info.storeType === 'restaurant' ? '餐廳' : '商店'}}時間頁面</button>
      </div>
    </div>
    <div v-if="storeType==='restaurant'">

      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-人數下方說明`" :defaultValue="info.reserveNumDesc" @save="update({reserveNumDesc:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-時段說明`" :defaultValue="info.visitTimeDesc" @save="update({visitTimeDesc:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-底層備註`" :defaultValue="info.VisitFooterDesc" @save="update({VisitFooterDesc:$event})"/>
      <div class="switchs">
        <div>預約-預約成功推播</div>
        <div>
          <div label="強制推播"><input type="checkbox" :checked="info.forcePushMessage"  @change="$emit('update', { 'forcePushMessage': $event.target.checked })"></div>
        </div>
      </div>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-預約成功備註`" :defaultValue="info.successFooterDesc" @save="update({successFooterDesc:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-預約成功提示`" :defaultValue="info.successBookingAlert" @save="update({successBookingAlert:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-點餐完成提示`" :defaultValue="info.successOrderAlert" @save="update({successOrderAlert:$event})"/>
    </div>
    <div v-else-if="storeType==='shop'"><editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-時段說明`" :defaultValue="info.visitTimeDesc" @save="update({visitTimeDesc:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-底層備註`" :defaultValue="info.VisitFooterDesc" @save="update({VisitFooterDesc:$event})"/>
      <div class="switchs">
        <div>預購-預購成功推播</div>
        <div>
          <div label="強制推播"><input type="checkbox" :checked="info.forcePushMessage"  @change="$emit('update', { 'forcePushMessage': $event.target.checked })"></div>
        </div>
      </div>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-預訂成功備註`" :defaultValue="info.successFooterDesc" @save="update({successFooterDesc:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-預訂成功提示(自取)`" :defaultValue="info.successBookingAlert" @save="update({successBookingAlert:$event})"/>
      <editCube :title="`預${info.storeType === 'shop' ? '購' : '約'}-預訂成功提示(宅配)`" :defaultValue="info.successBookingAlertTakeout" @save="update({successBookingAlertTakeout:$event})"/>
      <editCube :title="'付款資訊頁-勾選項目1'"  :defaultValue="info.InvoiceNote||''" @save="update({InvoiceNote:$event})">
        <switchVue :defaultValue="info.showInvoiceNote" @update="update({showInvoiceNote:$event})"/>
      </editCube>
      <editCube :title="'付款資訊頁-勾選項目2'"  :defaultValue="info.ReturnNote||''" @save="update({ReturnNote:$event})">
        <switchVue :defaultValue="info.showReturnNote" @update="update({showReturnNote:$event})"/>
      </editCube>
      <editCube :title="'付款資訊頁-勾選項目3-退換貨政策'"  :defaultValue="info.ReturnPolicy||''" @save="update({ReturnPolicy:$event})">
        <switchVue :defaultValue="info.showReturnPolicy" @update="update({showReturnPolicy:$event})"/>
      </editCube>
      <editCube :title="'付款資訊頁-勾選項目4-服務條款'"  :defaultValue="info.ToS||''" @save="update({ToS:$event})">
        <switchVue :defaultValue="info.showToS" @update="update({showToS:$event})"/>
      </editCube>
    </div>
    <div class="alarm" v-if="alertshow" :style="{height: 'fit-content!important'}">網址已複製!<br>{{alertshow}}</div>
    <div class="alarm error" v-if="LinkError" :style="{height: 'fit-content!important'}">{{LinkError}}</div>
  </div>
</template>

<script>
import switchVue from '../../components/radio/switch.vue'
import editCube from '../../components/editCubeV2.vue'
import { uploadimage } from '../../store/fetch'
import File from '../../components/input/fileinfo.vue'
import File4 from '../../components/input/file4.vue'
import draggable from 'vuedraggable'
const { VUE_APP_HOST, VUE_APP_LIFF } = process.env
export default {
  props: ['info'],
  components: {
    switchVue,
    File4,
    File,
    editCube,
    draggable
  },
  data () {
    return {
      LinkError: null,
      alertshow: false,
      editMsg: false,
      editRMsg: false,
      editGMsg: false,
      edit: null,
      restBookImage: null,
      restaurants: [],
      image: null,
      imageA: null,
      imageArray: [],
      icon: null,
      description: null,
      restBookDescription: null,
      VUE_APP_HOST
    }
  },
  name: '',
  async mounted () {
  },
  computed: {
    storeType () {
      return this.info.storeType
    }
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler () {
        this.edit = null
        this.editMsg = false
        this.editRMsg = false
        this.editGMsg = false
        if (this.info) {
          this.image = this.info.restBookImage
          this.icon = this.info.icon
          this.restBookDescription = this.info.restBookDescription
        }
      }
    }
  },
  methods: {
    addImage2Array (ev) {
      console.log('[addImage2Array]', ev)
      if (ev) {
        this.imageArray.push(ev)
      }
    },
    getLink (page) {
      const type = this.info.storeType === 'restaurant' ? 'rest' : 'shop'
      const link = encodeURI(`${VUE_APP_LIFF}/${type}${page}?store_name=${this.info.name}`)
      return link
    },
    async copylink (page) {
      const type = this.info.storeType === 'restaurant' ? 'rest' : 'shop'
      const link = encodeURI(`${VUE_APP_LIFF}/${type}${page}?store_name=${this.info.name}`)
      try {
        const x = await this.$copyText(link)
        if (x) {
          this.Link = '複製成功'
          this.alertshow = link
          setTimeout(() => {
            this.Link = null
          }, 2000)
          setTimeout(() => {
            this.alertshow = null
          }, 5000)
        }
      } catch (error) {
        this.LinkError = '複製失敗'
        setTimeout(() => {
          this.LinkError = null
        }, 2000)
      }
    },
    update (value) {
      this.$emit('update', value)
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      if (ret) {
        console.log('image, ret', ret)
        const image = `/${folder}/${ret}`
        this.image = image
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: 65px;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;
    &>div {
      width: 220px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-inline: 14px;
      border: 2px dashed var(--color-checked);
      border-radius: 5px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85CA9E;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85CA9E;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-checked);
    width: -webkit-fill-available;

  }
}
.linkBtns {
  display: flex;
  flex-direction: column;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  text-align: start;
  .linkBtn {
    height: 70px;
    font-size: 22px;
    letter-spacing: .1em;
    font-weight: bold;
    width: 100%;
    background-color: var(--color-checked);
    color: #FFFFFF;
    border-radius: 3px;
  }
}
.alarm {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: var(--color-infobox);
  color: var(--color-pri);
  height: 3em;
  border-radius: 3px;
  font-size: 20px;
  text-align: start;
  border: none;
  &.error {
    background-color: var(--highlight);
  }
}
.editCube {
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.imagebox2 {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  &>img, &>.img>img {
    resize: both;
    max-width: 461px;
    max-height: 346px;
    width: auto;
  }
  .img {
    position: relative;
  }
  .deleteBtn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 60px;
    height: 60px;
    background-color: #00000099;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: '';
      background-color: #FFFFFF;
      mask-image: url(/svg/btn/del1.svg);
      display: inline-flex;
      width: 40px;
      height: 40px;
      mask-repeat: no-repeat;
      mask-position: center;
      mask-size: 30px;
    }
  }
}
.resttitle {
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 20px;
  gap: 9px;
  textarea, p {
    padding: 16px 20px;
    border: 1px solid var(--color-border);
    min-height: 560px;
    height: fit-content;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
  }
  &>div:nth-child(1) {
    width: 461px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
}
label#uploadimage {
  width: 461px;
  height: 346px;
}
.imagebox {
  width: 461px;
  height: 346px;
  background-color: #DADADA;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  // &::before {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(37deg);
  // }
  // &::after {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(-37deg);
  // }
}
.uploadimage {
  margin-right: auto;
  width: 461px;
  height: 346px;
  background-image: url(./upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 230px;
    top: 204px;
    transform: translateX(-50%);
  }
}
.restbooksetting {
  width: 100%;
  height: calc(100vh - 90px);
  display: grid;
  grid-template-columns: 1fr 1fr 1.3fr;
  &>div {
    padding: 28px 43px;
    overflow-y: auto;
    height: calc(100vh - 90px);
    box-sizing: border-box;
  }
  &>div:not(:first-child) {
    border-left: 1px solid var(--color-border);
  }
}

</style>
